// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__1Y_w3","addWidgetButton":"Header_addWidgetButton__2bU2z","dashboardTabs":"Header_dashboardTabs__2MOfZ","active":"Header_active__39ZfE"};